import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cscPasswordChecker = {
  gap: css`var(--csc-password-checker-gap, ${csSpacing.spacing04})`,
  rowGap: css`var(--csc-password-checker-row-gap, ${csSpacing.spacing04})`,
  iconColor: css`var(--csc-password-checker-icon-color, ${csColorText.muted})`,
  iconColorMet: css`var(--csc-password-checker-icon-color-met, ${csColorFunctional.success})`,
}

export const style: CSSResult = css`
  .csc-password-checker {
    display: flex;
    flex-direction: column;
    gap: ${cscPasswordChecker.gap};
  }

  cse-list {
    --cse-list-gap: ${cscPasswordChecker.gap};
    --cse-list-row-gap: ${cscPasswordChecker.rowGap};
  }

  cse-icon {
    --cse-icon-color: ${cscPasswordChecker.iconColor};
  }

  .met cse-icon {
    --cse-icon-color: ${cscPasswordChecker.iconColorMet};
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`
